export const CONSTANTS = {
  SCREEN_GROUP: 'user',
  LIST_ALL: 'list-user-all',
} as const;
